angular.module('bmsApp.sm.job').controller('SMJobMainCtrl',
	function ($state,
			  $scope) {

		$scope.$on('jobIndexUpdated', function (e, jobData) {
			$scope.jobData = jobData;
		});

		$scope.$on("closeJobUpdated", function (e, data) {
			$scope.closeJobData = data;
		});

		$scope.exportJobs = function () {
			$scope.$broadcast('smJobIndexExport', {});
			console.log('smJobIndexExport');
		};

	});
